import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  site_info,
  banner_info,
  aboutus_info,
  services_info,
  faq_info,
  blog_info,
  menu_info,
  home_UBT,
  single_service,
  home_grammer_cat,
  home_Grammmar,
  home_Dictionary,
  single_home_Dictionary,
  single_home_Grammmar,
  allDictionary,
  all_product,
  blog_category,
  blog_category_single,
  single_booknotes,
} from "./HomeApi";

const initialState = {
  appVersion: 0,
  isLoading: false,
  siteInfo: {},
  bannerInfo: {},
  aboutusInfo: {},
  servicesInfo: {},
  servicesSEO: {},
  faqInfo: [],
  blogInfo: [],
  singleBlogContent: {},
  socialLinks: [],
  menuLinks: [],
  bottomLinks: [],
  aboutLinks: [],
  resourcesLinks: [],
  homeModuleLoading: false,
  selectedSingleService: {},
  homeModule: [],
  homeGrammerCat: [],
  singleHomeModule: {},
  allDictionary: [],
  errorHandle: "",
  allProduct: {},
  allblogcategory: [],
  selectedBlogCategory: "",
  singlebooknotes: {},
};

// ------------------------ Async Thunks ------------------------ //

export const singleBookNote = createAsyncThunk(
  "home/singlebooknote",
  async (data) => {
    try {
      return await single_booknotes(data);
    } catch (err) {
      return {};
    }
  }
);

export const allblogCateogory = createAsyncThunk(
  "home/allblogcategory",
  async () => {
    try {
      return await blog_category();
    } catch (err) {
      return {};
    }
  }
);

export const blogcategorysingle = createAsyncThunk(
  "home/blogcategorysingle",
  async (data) => {
    try {
      return await blog_category_single(data);
    } catch (err) {
      return {};
    }
  }
);

export const allProducts = createAsyncThunk("home/allProduct", async () => {
  try {
    return await all_product();
  } catch (error) {
    return {};
  }
});

export const collectDictionary = createAsyncThunk(
  "home/collectDictionary",
  async () => {
    try {
      return await allDictionary();
    } catch (error) {
      return {};
    }
  }
);

export const siteInfo = createAsyncThunk("home/siteInfo", async (data) => {
  try {
    return await site_info(data);
  } catch (error) {
    return {};
  }
});

export const bannerInfo = createAsyncThunk("home/bannerInfo", async (data) => {
  try {
    return await banner_info(data);
  } catch (error) {
    return {};
  }
});

export const aboutusInfo = createAsyncThunk(
  "home/aboutusInfo",
  async (data) => {
    try {
      return await aboutus_info(data);
    } catch (error) {
      return {};
    }
  }
);

export const servicesInfo = createAsyncThunk(
  "home/servicesInfo",
  async (data) => {
    try {
      return await services_info(data);
    } catch (error) {
      return {};
    }
  }
);

export const singleServiceInfo = createAsyncThunk(
  "home/singleServiceInfo",
  async (id) => {
    try {
      const res = await fetch(
        `https://secureadmin.lkwb.com.np/api/service/${id}`
      );
      const data = await res.json();
      return data?.data || {};
    } catch (error) {
      return {};
    }
  }
);

export const faqInfo = createAsyncThunk("home/faqInfo", async (data) => {
  try {
    return await faq_info(data);
  } catch (error) {
    return {};
  }
});

export const blogInfo = createAsyncThunk("home/blogInfo", async (data) => {
  try {
    return await blog_info(data);
  } catch (error) {
    return {};
  }
});

export const menuInfo = createAsyncThunk("home/menuInfo", async (data) => {
  try {
    return await menu_info(data);
  } catch (error) {
    return {};
  }
});

export const singleService = createAsyncThunk(
  "home/singleService",
  async (data) => {
    try {
      return await single_service(data);
    } catch (error) {
      return {};
    }
  }
);

export const homeUBT = createAsyncThunk("home/homeUBT", async () => {
  try {
    return await home_UBT();
  } catch (error) {
    return {};
  }
});

export const homeDictionary = createAsyncThunk(
  "home/homeDictionary",
  async (data) => {
    try {
      return await home_Dictionary(data);
    } catch (error) {
      return {};
    }
  }
);

export const homeGrammar = createAsyncThunk("home/homeGrammar", async () => {
  try {
    return await home_Grammmar();
  } catch (error) {
    return {};
  }
});

export const homeGrammarCat = createAsyncThunk(
  "home/homeGrammarCat",
  async () => {
    try {
      return await home_grammer_cat();
    } catch (error) {
      return {};
    }
  }
);

export const singleHomeGrammar = createAsyncThunk(
  "home/singleGrammar",
  async (data) => {
    try {
      return await single_home_Grammmar(data);
    } catch (error) {
      return {};
    }
  }
);

export const singleHomeDictionary = createAsyncThunk(
  "home/singleDictionary",
  async (data) => {
    try {
      return await single_home_Dictionary(data);
    } catch (error) {
      return {};
    }
  }
);

// ------------------------ Slice ------------------------ //

const HomeSlice = createSlice({
  name: "Home",
  initialState,
  extraReducers: (builder) => {
    builder
      // --------------- singleBookNote ----------------- //
      .addCase(singleBookNote.pending, (state) => {
        state.isLoading = true;
        state.singlebooknotes = {};
      })
      .addCase(singleBookNote.fulfilled, (state, action) => {
        state.isLoading = false;
        state.singlebooknotes = action.payload?.data?.data || {};
      })
      .addCase(singleBookNote.rejected, (state) => {
        state.isLoading = false;
      })

      // --------------- allBlogCategory ----------------- //
      .addCase(allblogCateogory.fulfilled, (state, action) => {
        state.allblogcategory = action.payload?.data?.data || [];
      })

      // --------------- blogCategorySingle ----------------- //
      .addCase(blogcategorysingle.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(blogcategorysingle.fulfilled, (state, action) => {
        state.blogInfo = action.payload?.data?.data?.blogs || [];
        state.selectedBlogCategory =
          action.payload?.data?.data?.title || "";
        state.isLoading = false;
      })
      .addCase(blogcategorysingle.rejected, (state) => {
        state.blogInfo = [];
        state.isLoading = false;
      })

      // --------------- siteInfo ----------------- //
      .addCase(siteInfo.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(siteInfo.fulfilled, (state, action) => {
        state.isLoading = false;
        state.siteInfo = action.payload?.data?.data || {};
      })
      .addCase(siteInfo.rejected, (state) => {
        state.isLoading = false;
      })

      // --------------- bannerInfo ----------------- //
      .addCase(bannerInfo.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(bannerInfo.fulfilled, (state, action) => {
        state.isLoading = false;
        state.bannerInfo = action.payload?.data?.data || {};
      })
      .addCase(bannerInfo.rejected, (state) => {
        state.isLoading = false;
      })

      // --------------- aboutusInfo ----------------- //
      .addCase(aboutusInfo.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(aboutusInfo.fulfilled, (state, action) => {
        state.isLoading = false;
        state.aboutusInfo = action.payload?.data?.data || {};
      })
      .addCase(aboutusInfo.rejected, (state) => {
        state.isLoading = false;
      })

      // --------------- servicesInfo ----------------- //
      .addCase(servicesInfo.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(servicesInfo.fulfilled, (state, action) => {
        state.isLoading = false;
        state.servicesInfo = action.payload?.data?.data || {};
      })
      .addCase(servicesInfo.rejected, (state) => {
        state.isLoading = false;
      })

      // --------------- singleServiceInfo ----------------- //
      .addCase(singleServiceInfo.pending, (state) => {
        state.singleService = null;
        state.isLoading = true;
      })
      .addCase(singleServiceInfo.fulfilled, (state, action) => {
        state.singleService = action.payload || {};
        state.isLoading = false;
      })
      .addCase(singleServiceInfo.rejected, (state) => {
        state.singleService = null;
        state.isLoading = false;
      })

      // --------------- faqInfo ----------------- //
      .addCase(faqInfo.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(faqInfo.fulfilled, (state, action) => {
        state.isLoading = false;
        state.faqInfo = action.payload?.data?.data || [];
      })
      .addCase(faqInfo.rejected, (state) => {
        state.isLoading = false;
      })

      // --------------- blogInfo ----------------- //
      .addCase(blogInfo.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(blogInfo.fulfilled, (state, action) => {
        state.isLoading = false;
        state.selectedBlogCategory = "";
        state.blogInfo = action.payload?.data?.data || [];
      })
      .addCase(blogInfo.rejected, (state) => {
        state.isLoading = false;
      })

      // --------------- menuInfo ----------------- //
      .addCase(menuInfo.fulfilled, (state, action) => {
        const menuData = action.payload?.data?.data || [];
        const bottomMenu = menuData.find(
          (item) => item.id === 1 && item.slug === "bottom-footer-left-menu"
        );
        const topMenu = menuData.find(
          (item) => item.id === 2 && item.slug === "top-navigation-menu"
        );
        const aboutMenu = menuData.find(
          (item) => item.id === 3 && item.slug === "footer-company-menu"
        );
        const resourcesMenu = menuData.find(
          (item) => item.id === 4 && item.slug === "footer-resources-menu"
        );

        state.bottomLinks = bottomMenu?.menu_items || [];
        state.menuLinks = topMenu?.menu_items || [];
        state.aboutLinks = aboutMenu?.menu_items || [];
        state.resourcesLinks = resourcesMenu?.menu_items || [];
      })

      // --------------- homeUBT ----------------- //
      .addCase(homeUBT.pending, (state) => {
        state.homeModule = [];
        state.homeModuleLoading = true;
      })
      .addCase(homeUBT.fulfilled, (state, action) => {
        state.homeModule = action.payload?.data?.data || [];
        state.homeModuleLoading = false;
      })

      // --------------- homeDictionary ----------------- //
      .addCase(homeDictionary.pending, (state) => {
        state.homeModuleLoading = true;
      })
      .addCase(homeDictionary.fulfilled, (state, action) => {
        state.homeModuleLoading = false;
        const newData = action.payload?.data?.data || [];
        if (newData.length > 0) {
          const allData = new Set([...state.allDictionary, ...newData]);
          state.allDictionary = [...allData];
        } else {
          state.errorHandle = "No More Data To Load";
        }
      })

      // --------------- homeGrammar ----------------- //
      .addCase(homeGrammar.pending, (state) => {
        state.homeModuleLoading = true;
        state.homeModule = [];
      })
      .addCase(homeGrammar.fulfilled, (state, action) => {
        state.homeModuleLoading = false;
        state.homeModule = action.payload?.data?.data || [];
      })

      // --------------- singleHomeGrammar ----------------- //
      .addCase(singleHomeGrammar.pending, (state) => {
        state.homeModuleLoading = true;
        state.homeModule = {};
      })
      .addCase(singleHomeGrammar.fulfilled, (state, action) => {
        state.homeModuleLoading = false;
        state.singleHomeModule = action.payload?.data?.data || {};
      })

      // --------------- singleHomeDictionary ----------------- //
      .addCase(singleHomeDictionary.pending, (state) => {
        state.homeModuleLoading = true;
        state.homeModule = {};
      })
      .addCase(singleHomeDictionary.fulfilled, (state, action) => {
        state.homeModuleLoading = false;
        state.singleHomeModule = action.payload?.data?.data || {};
      })

      // --------------- collectDictionary ----------------- //
      .addCase(collectDictionary.fulfilled, (state, action) => {
        localStorage.setItem(
          "allDictionary",
          JSON.stringify(action.payload?.data?.data || [])
        );
      })

      // --------------- singleService ----------------- //
      .addCase(singleService.pending, (state) => {
        state.isLoading = true;
        state.selectedSingleService = {};
      })
      .addCase(singleService.fulfilled, (state, action) => {
        state.isLoading = false;
        state.selectedSingleService = action.payload?.data?.data || {};
      })

      // --------------- homeGrammarCat ----------------- //
      .addCase(homeGrammarCat.fulfilled, (state, action) => {
        state.homeGrammerCat = action.payload?.data?.data || [];
      })

      // --------------- allProducts ----------------- //
      .addCase(allProducts.fulfilled, (state, action) => {
        state.allProduct = action.payload?.data?.data || {};
        localStorage.setItem(
          "onlineRedirect",
          action.payload?.data?.data?.online_classes?.url || ""
        );
        localStorage.setItem(
          "recordings",
          action.payload?.data?.data?.recordings?.url || ""
        );
      });
  },
});

export default HomeSlice.reducer;
